var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMssql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1414_1809",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0H0.5V32H31.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1414_1809)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1414_1809",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0H0.5V32H31.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1414_1809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 22.4C22.8471 22.4 28.3989 24.5489 28.3989 27.2V17.5999C28.3989 14.9489 22.8471 12.7999 15.9989 12.7999H12.8989V22.4H15.9989Z",
    fill: "url(#paint0_linear_1414_1809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3991 17.5999C28.3991 20.2509 22.8475 22.3998 15.9991 22.3998C11.8225 22.3998 8.1282 21.6005 5.88139 20.3755C4.66475 19.8187 3.59912 20.6624 3.59912 21.8061V27.1998C3.59912 29.8509 9.15081 31.9998 15.9991 31.9998C22.8475 31.9998 28.3991 29.8509 28.3991 27.1998V17.5999Z",
    fill: "url(#paint1_radial_1414_1809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3991 17.5999C28.3991 20.2509 22.8475 22.3998 15.9991 22.3998C11.8225 22.3998 8.1282 21.6005 5.88139 20.3755C4.66475 19.8187 3.59912 20.6624 3.59912 21.8061V27.1998C3.59912 29.8509 9.15081 31.9998 15.9991 31.9998C22.8475 31.9998 28.3991 29.8509 28.3991 27.1998V17.5999Z",
    fill: "url(#paint2_radial_1414_1809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 0C22.8474 0 28.3992 2.14903 28.3992 4.8V10.2375C28.3992 10.9813 27.6483 12.2875 26.115 11.6233C23.8678 10.3989 20.1745 9.6 15.9991 9.6C9.15081 9.6 3.59912 11.749 3.59912 14.4V4.8C3.59912 2.14903 9.15081 0 15.9991 0Z",
    fill: "url(#paint3_linear_1414_1809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 9.59985C9.15082 9.59985 3.59912 7.45085 3.59912 4.79987V14.3998C3.59912 17.0508 9.15082 19.2 15.9991 19.2H16.7741C18.0582 19.2 19.0992 18.1253 19.0992 16.7998V11.9998C19.0992 10.6744 18.0582 9.59985 16.7741 9.59985H15.9991Z",
    fill: "url(#paint4_radial_1414_1809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 9.59985C9.15082 9.59985 3.59912 7.45085 3.59912 4.79987V14.3998C3.59912 17.0508 9.15082 19.2 15.9991 19.2H16.7741C18.0582 19.2 19.0992 18.1253 19.0992 16.7998V11.9998C19.0992 10.6744 18.0582 9.59985 16.7741 9.59985H15.9991Z",
    fill: "url(#paint5_radial_1414_1809)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1414_1809",
    x1: 23.7489,
    y1: 12.7999,
    x2: 10.4577,
    y2: 23.4649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243047,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584404,
    stopColor: "#2052CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830639,
    stopColor: "#312A9A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1414_1809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.5 11.8001 -20.3224 -28.4444 22.1991 19.6999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1414_1809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.95 9.59999 -15.6896 -24.2937 26.0741 18.3998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECBFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DECBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1414_1809",
    x1: 21.4242,
    y1: 0.8,
    x2: 6.23719,
    y2: 16.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162714,
    stopColor: "#0094F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563871,
    stopColor: "#2052CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764283,
    stopColor: "#312A9A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1414_1809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.748 11.1006 -16.7502 -18.8891 15.7853 8.09918)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1414_1809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.625 7.20004 -11.1648 -19.2081 18.3242 7.19985)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECBFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMssql);
export default __webpack_public_path__ + "static/media/mssql.5a6afc853330005b61eaa38b050dca9e.svg";
export { ForwardRef as ReactComponent };